// BlogList.js
import React from 'react';
import { Link } from 'react-router-dom';
import './BlogEstilo.css';

const blogPosts = [
  {
    id: 1,
    title: 'VidaPet.Tech é Selecionada para o Programa de Aceleração do Ibmec Hubs Rio de Janeiro',
    date: '30/09/2024',
    category: 'Novidade',
    summary: 'VidaPet.Tech foi escolhida para integrar o renomado programa de aceleração do Ibmec Hubs Rio de Janeiro, um dos principais centros de inovação do Brasil.',
    imageUrl: 'https://midias.jb.com.br/_midias/jpg/2021/04/07/ibmec-592121.jpg',
  },
  {
    id: 2,
    title: 'Quantas vacinas um cão precisa tomar durante sua vida?',
    date: '14/09/2024',
    category: 'Saúde Pet',
    summary: 'Saiba quais são as principais vacinas que um cão precisa tomar e com que frequência.',
    imageUrl: 'https://labovet.com.br/wp-content/uploads/2019/03/vacina_caes_widexl.png',
  },
  {
    id: 3,
    title: 'Campanha de Vacinação Antirrábica Animal em Maricá',
    date: '19/11/2024',
    category: 'Saúde Pet',
    summary: 'A Prefeitura de Maricá realizará a Campanha de Vacinação Antirrábica Animal nos dias 23 e 30 de novembro de 2024. A vacinação é gratuita e visa proteger cães e gatos contra a raiva.',
    imageUrl: 'https://www.usatoday.com/money/blueprint/images/uploads/2023/12/22013152/dog-vaccinations-cost-e1703223437156.jpg?width=700&fit=cover&format=webp',  // Substitua com a URL da imagem apropriada.
  },
];

const BlogList = () => {
  return (
    <div className="blog-list">
      <h2>Blog & Notícias</h2>
      <div className="other-posts">
        {blogPosts.map((post, index) => (
          <div key={post.id} className="blog-post">
            <img src={post.imageUrl} alt={post.title} />
            <div className="blog-post-content">
              <span className="blog-post-date">{post.date}</span>
              <span className="blog-post-category">{post.category}</span>
              <h3>{post.title}</h3>
              <p>{post.summary}</p>
              <Link to={`/post/${post.id}`}>
                <button>Leia Mais</button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
